import React from 'react';
import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import RevieweesDirectory from './RevieweesDirectory';
import {RevieweeResultsContainer} from './view';

const RevieweesPage = observer(({scope, match}) => {
  return (
    <Switch>
      {scope.reviewees && <Route exact path={match.path} render={() => <RevieweesDirectory scope={scope}/>}/>}
      <Route path={`${match.path}/:revieweeId/employee/:employeeId/:revieweeUrlSlug?/:backPath?`} render={({match}) => <RevieweeResultsContainer match={match}/>}/>
    </Switch>
  );
});

export default RevieweesPage;
